module.exports = __webpack_public_path__ + "static/NEW-LOGO-2019-1d2421b0ef1ca63411b07d126f37aeae.png";